// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5271) return "5271.0f96b6cfe8b64011bc71.js";
	// return url for filenames based on template
	return "" + {"1167":"cb23c0249b7854640865","7586":"056c707fb523144c7a03"}[chunkId] + ".js";
};